import React from 'react';
import { Typography, Tag, Space, List } from 'antd';
import { CalendarOutlined, UserOutlined, DownloadOutlined, LockOutlined } from '@ant-design/icons';
import PortalHtml from './PortalHtml';
import './portal.css';

const { Title, Text } = Typography;

const PortalPostArticle = ({ post, compact = false }) => {
  if (!post) return null;

  return (
    <article style={{ maxWidth: 760, margin: compact ? 0 : '0 auto', padding: compact ? 0 : '32px 0 64px' }}>
      {post.categoryName && (
        <Text type="secondary" style={{ display: 'block', fontSize: 13, letterSpacing: 0.4, marginBottom: 8 }}>
          {post.categoryName}
        </Text>
      )}
      {post.needsPassword && (
        <Tag icon={<LockOutlined />} style={{ marginBottom: 12 }}>Password protected</Tag>
      )}

      <Title style={{ fontSize: compact ? 28 : 'clamp(28px, 5vw, 42px)', marginTop: 0, marginBottom: 16, lineHeight: 1.2 }}>
        {post.title || 'Untitled'}
      </Title>

      <Space wrap size={16} style={{ marginBottom: 24, paddingBottom: 20, borderBottom: '1px solid #eceff2' }}>
        {post.publishedAt && (
          <Text type="secondary">
            <CalendarOutlined style={{ marginRight: 6 }} />
            {new Date(post.publishedAt).toLocaleDateString(undefined, { day: 'numeric', month: 'long', year: 'numeric' })}
          </Text>
        )}
        {post.authorName && (
          <Text type="secondary">
            <UserOutlined style={{ marginRight: 6 }} />
            {post.authorName}
          </Text>
        )}
      </Space>

      {post.featuredMediaUrl && (
        <img
          src={post.featuredMediaUrl}
          alt=""
          style={{ width: '100%', borderRadius: 10, marginBottom: 32, display: 'block' }}
        />
      )}

      <PortalHtml html={post.bodyHtml} className="portal-article" />

      {post.attachments?.length > 0 && (
        <div style={{ marginTop: 40, paddingTop: 24, borderTop: '1px solid #eceff2' }}>
          <Title level={4}>Downloads</Title>
          <List
            dataSource={post.attachments}
            renderItem={(file) => (
              <List.Item>
                <a href={file.url} target="_blank" rel="noopener noreferrer">
                  <DownloadOutlined style={{ marginRight: 8 }} />
                  {file.name}
                </a>
                <Text type="secondary" style={{ marginLeft: 8 }}>
                  {file.size ? `${(file.size / 1024).toFixed(1)} KB` : ''}
                </Text>
              </List.Item>
            )}
          />
        </div>
      )}

      {post.tagNames?.length > 0 && (
        <Space wrap style={{ marginTop: 32 }}>
          {post.tagNames.map((t) => <Tag key={t}>{t}</Tag>)}
        </Space>
      )}
    </article>
  );
};

export default PortalPostArticle;
